import app from 'Cloud/Application/app';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { isDefaultRootContent } from 'reactApp/modules/home/home.selectors';
import { store as reduxStore } from 'reactApp/store';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

export const isWelcomePromo = () =>
    app?.isHome() && app.getState && app.getState().id === '/' && isDefaultRootContent(reduxStore.getState());

const { utm_source, utm_campaign, utm_term } = getQueryParams();

export const sendAuthDwh = (action, source = '') => {
    sendDwh({
        eventCategory: ECategoryGa.onboarding,
        action,
        dwhData: {
            source,
            utm_source,
            utm_campaign,
            utm_term,
        },
    });
};
